import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-335" data-mp="2nvnd7bjtx8f3">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-336" data-mp="2sw1l8tlfkid4">
        <div data-id="element-337" data-mp="2stoy820tfht7">
          <p className="font-heading text-sm font-semibold text-white" data-id="element-338" data-mp="o0l1ah0cu6hr">19€</p>
          <p className="text-[11px] text-muted" data-id="element-339" data-mp="o2o11srb7dzo">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-340" data-mp="s2omvygqmrgr">
          Quiero el Manual
        </PrimaryButton>
      </div>
    </div>;
}